import './ARJack.css';
import { useState } from "react";
import './Header.css';

import logoBosoTokyoWebp from '../img/logo-boso-tokyo.webp';
import logoBosoTokyo from '../img/logo-boso-tokyo.png';
import logoOpenseaWebp from '../img/logo-opensea.webp';
import logoOpensea from '../img/logo-opensea.png';
import logoDiscordWebp from '../img/logo-discord.webp';
import logoDiscord from '../img/logo-discord.png';
import logoTwitterWebp from '../img/logo-twitter.webp';
import logoTwitter from '../img/logo-twitter.png';
import menuIconOpen from '../img/icons/menu-icon-open.svg';
import menuIconClose from '../img/icons/menu-icon-close.svg';

import { Link } from "react-router-dom";

import HeroImg from '../img/Firstanniv/231029womb/hero_img.webp';
import HeroTextImgSp from '../img/Firstanniv/231029womb/event_copy_sp.svg';
import HeroTextImgPc from '../img/Firstanniv/231029womb/event_copy_pc.svg';

import HIYADAM from '../img/Firstanniv/231029womb/HIYADAM.webp';
import SANTAWORLDVIEW from '../img/Firstanniv/231029womb/SANTAWORLDVIEW.webp';
import live_3 from '../img/Firstanniv/231029womb/live_3.webp';
import Ashley from '../img/Firstanniv/231029womb/Ashley.webp';
import Kvi_Baba from '../img/Firstanniv/231029womb/Kvi_Baba.webp';
import and_more from '../img/Firstanniv/231029womb/and_more.webp';

import DJ_TATSUKI from '../img/Firstanniv/231029womb/DJ_TATSUKI.webp';
import FUJI_TRILL from '../img/Firstanniv/231029womb/FUJI_TRILL.webp';
import UWTO_BLND from '../img/Firstanniv/231029womb/UWTO_BLND.webp';

import LIVE_DJ from '../img/Firstanniv/231029womb/LIVE_DJ.webp';
import ARTWORK from '../img/Firstanniv/231029womb/ARTWORK.webp';
import SPACE from '../img/Firstanniv/231029womb/SPACE.webp';
import SHISHA from '../img/Firstanniv/231029womb/SHISHA.webp';
import GOODS from '../img/Firstanniv/231029womb/GOODS.webp';

import afromance from '../img/Firstanniv/231029womb/afromance.webp';
import cyber_okan from '../img/Firstanniv/231029womb/cyber_okan.webp';
import DeFitter from '../img/Firstanniv/231029womb/DeFitter.webp';
import DJ_sakoo from '../img/Firstanniv/231029womb/DJ_sakoo.webp';
import DJ_SHIN from '../img/Firstanniv/231029womb/DJ_SHIN.webp';
import kasumi from '../img/Firstanniv/231029womb/kasumi.webp';
import ikuma_Nagano from '../img/Firstanniv/231029womb/ikuma_Nagano.webp';
import Satoshi_Miya from '../img/Firstanniv/231029womb/Satoshi_Miya.webp';
import spia from '../img/Firstanniv/231029womb/spia.webp';
import do_do_tom from '../img/Firstanniv/231029womb/do_do_tom.webp';
import VJ_guro from '../img/Firstanniv/231029womb/VJ_guro.webp';
import YOU_MATSUZAKI from '../img/Firstanniv/231029womb/YOU_MATSUZAKI.webp';
import YUME from '../img/Firstanniv/231029womb/YUME.webp';
import UNA from '../img/Firstanniv/231029womb/UNA.webp';

import timeTable from '../img/Firstanniv/231029womb/timetable.webp';
import aboutImg from '../img/Firstanniv/about_img.png';

import galleryImg01 from '../img/Firstanniv/231029womb/Gallery/01.webp';
import galleryImg02 from '../img/Firstanniv/231029womb/Gallery/02.webp';
import galleryImg03 from '../img/Firstanniv/231029womb/Gallery/03.webp';
import galleryImg04 from '../img/Firstanniv/231029womb/Gallery/04.webp';
import galleryImg05 from '../img/Firstanniv/231029womb/Gallery/05.webp';
import galleryImg06 from '../img/Firstanniv/231029womb/Gallery/06.webp';
import galleryImg07 from '../img/Firstanniv/231029womb/Gallery/07.webp';
import galleryImg08 from '../img/Firstanniv/231029womb/Gallery/08.webp';
import galleryImg09 from '../img/Firstanniv/231029womb/Gallery/09.webp';
import galleryImg10 from '../img/Firstanniv/231029womb/Gallery/10.webp';
import galleryImg11 from '../img/Firstanniv/231029womb/Gallery/11.webp';
import galleryImg12 from '../img/Firstanniv/231029womb/Gallery/12.webp';

import headingIcon from '../img/Firstanniv/heading_icon.webp';
import XIcon from '../img/icons/x_logo.svg';
import OpenseaIcon from '../img/icons/opensea_logo.svg';
import FooterLogo from '../img/Firstanniv/footer_logo.webp';




export default function Womb() {
    const Header = () => {
        const [isModalOpen, setIsModalOpen] = useState(false);

        const Menu = () => {
            return (
                <div className="Header__menu">
                    <div className="Header__logo glitchPatternInfinite05">
                        <Link to="/">
                            <picture>
                                <source type="image/webp" srcSet={logoBosoTokyoWebp} />
                                <img src={logoBosoTokyo} alt="BoSo TOKYO ロゴ" />
                            </picture>
                        </Link>
                    </div>
                    <div className="Header__rightContainer">
                        <nav className="Header__nav">
                            <ul>
                                <li><a href="#LINE_UP">LINE UP</a></li>
                                <li><a href="#CONTENTS">CONTENTS</a></li>
                                <li><a href="#TICKET">TICKET</a></li>
                                {/* <li><a href="#CREW">BOSO CREW</a></li> */}
                                <li><a href="#INFO">INFO</a></li>
                                {/* <li><a href="#FAQ">FAQ</a></li> */}
                                <li><a href="#GALLERY">GALLERY</a></li>
                                <li><a href="#ABOUT">ABOUT</a></li>
                            </ul>
                        </nav>

                        <div className="Header__icon">
                            <a href="https://opensea.io/collection/bosotokyo-official" target="_blank">
                                <picture>
                                    <source type="image/webp" srcSet={logoOpenseaWebp} />
                                    <img src={logoOpensea} alt="OpenSea link" />
                                </picture>
                            </a>
                        </div>
                        <div className="Header__icon glitchPatternInfinite03">
                            <a href="https://discord.gg/bosotokyo" target="_blank">
                                <picture>
                                    <source type="image/webp" srcSet={logoDiscordWebp} />
                                    <img src={logoDiscord} alt="Discord link" />
                                </picture>
                            </a>
                        </div>
                        <div className="Header__icon glitchPatternInfinite04">
                            <a href="https://twitter.com/BosoTokyo" target="_blank">
                                <picture>
                                    <source type="image/webp" srcSet={logoTwitterWebp} />
                                    <img src={logoTwitter} alt="Twitter link" />
                                </picture>
                            </a>
                        </div>

                        <div className="Header__menuBtn">
                            <button onClick={() => setIsModalOpen(!isModalOpen)}><img src={isModalOpen ? menuIconClose : menuIconOpen} alt="sp menu open" /></button>
                        </div>

                    </div>
                </div>
            )
        }

        return (

            <>
                {isModalOpen ? (
                    <header className="Header open" id="HeaderLogo">
                        <Menu />
                        <div className="Header__Modal">
                            <Menu />
                            <nav className="Header__nav__firstanniv--sp">
                                <ul>
                                    <li><a href="#LINE_UP">LINE UP</a></li>
                                    <li><a href="#CONTENTS">CONTENTS</a></li>
                                    <li><a href="#TICKET">TICKET</a></li>
                                    <li><a href="#CREW">BOSO CREW</a></li>
                                    <li><a href="#INFO">INFO&ACCESS</a></li>
                                    <li><a href="#FAQ">FAQ</a></li>
                                    <li><a href="#GALLERY">GALLERY</a></li>
                                    <li><a href="#ABOUT">ABOUT</a></li>
                                </ul>
                            </nav>
                        </div>
                    </header>

                ) : (
                    <header className="Header" id="HeaderLogo">
                        <Menu />
                    </header>
                )}
            </>

        );
    }

    const Gallery = ({ imgSrc }) => {
        const [isGalleryModalOpen, setIsGalleryModalOpen] = useState(false);

        return (
            <>
                <button onClick={() => setIsGalleryModalOpen(!isGalleryModalOpen)}>
                    <img src={imgSrc} alt="img" />
                </button>
                <>
                    {isGalleryModalOpen ? (
                        <>
                            <div className='gallery__modal'>
                                <button onClick={() => setIsGalleryModalOpen(!isGalleryModalOpen)}>
                                    <div className='gallery__modal__background'></div>
                                    <div className='gallery__modal__img'>
                                        <img src={imgSrc} alt="img" />
                                    </div>
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                        </>
                    )}
                </>
            </>
        )
    }

    const AboutItem = ({ children, title }) => {
        return (
            <div className="ARJack__about__item">
                <h3 className="ARJack__about__item__h3">{title}</h3>
                <div className="ARJack__about__item__content">
                    {children}
                </div>
            </div>
        )
    }

    const GridItem = (props) => {
        return (
            <div className="ARJack__GridItem">
                <div className="ARJack__GridItem__img">
                    <img src={props.img} alt={props.alt} />
                </div>
                <p className="firstanniv__GridItem__name">{props.name}</p>
                <p className="ARJack__GridItem__prize">{props.prize}</p>
            </div>
        )
    }

    return (
        <>
            <Header />
            <div className="ARJack">

                <div className="ARJack__heroImg">
                    <img className="ARJack__heroMainImg" src={HeroImg} alt="BOSO TOKYO 1st ANNIV. PARTY 2023.10.29 SUM OPEN/START 17:00 - 22:00 at WOMB SHIBUYA" />
                </div>

                <div className="firstanniv__main">

                    <img className="firstanniv__heroTextImg__sp" src={HeroTextImgSp} alt="サイバーSF×暴走族カルチャーをテーマにした日本発のNFTプロジェクト「BŌSŌ TOKYO 暴走東京」の１周年パーティー。10/29(日) ハロウィンの狂騒の先、渋谷WOMBで展開されるBŌSŌの世界観が表現された空間、アーティストのLIVE、DJ、アートワークの展示。さぁ、祝祭を始めよう。" />
                    <img className="firstanniv__heroTextImg__pc" src={HeroTextImgPc} alt="サイバーSF×暴走族カルチャーをテーマにした日本発のNFTプロジェクト「BŌSŌ TOKYO 暴走東京」の１周年パーティー。10/29(日) ハロウィンの狂騒の先、渋谷WOMBで展開されるBŌSŌの世界観が表現された空間、アーティストのLIVE、DJ、アートワークの展示。さぁ、祝祭を始めよう。" />

                    <section className="ARJack__about" id="LINE_UP">
                        <div className="firstanniv__sectionTitle">
                            <h2 className="firstanniv_h2_sectionTitle">LINE UP</h2>
                            <div className="firstanniv__sectionBorder"></div>
                            <img className='firstanniv_headingIcon' src={headingIcon} alt="heading icon" />
                        </div>
                        <span className='firstanniv_span'>A to Z</span>

                        <h3 className="firstanniv_h3">2F MAIN</h3>
                        <h4 className="firstanniv_h4">LIVE<span className='firstanniv_span'> (A to Z)</span></h4>
                        <div className="firstanniv__grid">
                            <GridItem img={Ashley} alt="icon" name="Ashley" prize="" />
                            <GridItem img={HIYADAM} alt="icon" name="HIYADAM" prize="" />
                            <GridItem img={Kvi_Baba} alt="icon" name="Kvi Baba" prize="" />
                            <GridItem img={SANTAWORLDVIEW} alt="icon" name="SANTAWORLDVIEW" prize="" />
                            <GridItem img={live_3} alt="icon" name="空音" prize="" />
                            {/* <GridItem img={and_more} alt="icon" name="and more" prize="" /> */}
                        </div>

                        <h4 className="firstanniv_h4">DJs<span className='firstanniv_span'> (A to Z)</span></h4>
                        <div className="firstanniv__grid">
                            <GridItem img={DJ_TATSUKI} alt="icon" name="DJ TATSUKI" prize="" />
                            <GridItem img={FUJI_TRILL} alt="icon" name="FUJI TRILL" prize="" />
                            <GridItem img={UWTO_BLND} alt="icon" name="UWTO BLND" prize="" />
                        </div>

                        <h4 className="firstanniv_h4">VJ</h4>
                        <div className="firstanniv__grid">
                            <GridItem img={ikuma_Nagano} alt="icon" name="ikuma Nagano" prize="" />
                        </div>

                        <h3 className="firstanniv_h3">1F LOUNGE</h3>
                        <h4 className="firstanniv_h4">DJs<span className='firstanniv_span'> (A to Z)</span></h4>
                        <div className="firstanniv__grid">
                            <GridItem img={afromance} alt="icon" name="afromance" prize="" />
                            <GridItem img={DeFitter} alt="icon" name="DeFitterジョン" prize="" />
                            <GridItem img={DJ_sakoo} alt="icon" name="DJ sakoo" prize="" />
                            <GridItem img={DJ_SHIN} alt="icon" name="DJ SHIN" prize="" />
                            <GridItem img={Satoshi_Miya} alt="icon" name="Satoshi Miya" prize="" />
                            <GridItem img={YOU_MATSUZAKI} alt="icon" name="YOU MATSUZAKI" prize="" />
                            <GridItem img={cyber_okan} alt="icon" name="サイバーおかん" prize="" />
                        </div>
                        <h4 className="firstanniv_h4">VJ</h4>
                        <div className="firstanniv__grid">
                            <GridItem img={do_do_tom} alt="icon" name="do_do_tom" prize="" />
                            <GridItem img={VJ_guro} alt="icon" name="VJ guro" prize="" />
                        </div>

                        <h3 className="firstanniv_h3">4F VIP LOUNGE</h3>
                        <h4 className="firstanniv_h4">DJs<span className='firstanniv_span'> (A to Z)</span></h4>
                        <div className="firstanniv__grid">
                            <GridItem img={spia} alt="icon" name="spia" prize="" />
                            <GridItem img={UNA} alt="icon" name="UNA" prize="" />
                            <GridItem img={YUME} alt="icon" name="YUME" prize="" />
                            <GridItem img={kasumi} alt="icon" name="霞" prize="" />
                        </div>

                        <img className='firstanniv_timetable' src={timeTable} alt="time table" />

                    </section>

                    <section className="ARJack__contents" id="CONTENTS">
                        <div className="firstanniv__sectionTitle">
                            <h2 className="firstanniv_h2_sectionTitle">CONTENTS</h2>
                            <div className="firstanniv__sectionBorder"></div>
                            <img className='firstanniv_headingIcon' src={headingIcon} alt="heading icon" />
                        </div>

                        <div className='firstanniv_contentsContainer'>
                            <div className='firstanniv_content'>
                                <img src={LIVE_DJ} alt="LIVE DJ" />
                                <h3>LIVE/DJ</h3>
                                <p>複数のフロアでのLIVE&DJパフォーマンス</p>
                            </div>
                            <div className='firstanniv_content'>
                                <img src={ARTWORK} alt="ARTWORK" />
                                <h3>ARTWORK</h3>
                                <p>BOSO TOKYOのアートワークの展示</p>
                            </div>
                            <div className='firstanniv_content'>
                                <img src={SPACE} alt="SPACE" />
                                <h3>SPACE</h3>
                                <p>BOSO TOKYOの世界観を表現した空間</p>
                            </div>
                            <div className='firstanniv_content'>
                                <img src={SHISHA} alt="SHISHA" />
                                <h3>SHISHA</h3>
                                <p>隠し部屋でのシーシャ体験</p>
                            </div>
                            <div className='firstanniv_content'>
                                <img src={GOODS} alt="GOODS" />
                                <h3>GOODS</h3>
                                <p>BOSO TOKYOの１周年グッズの販売</p>
                            </div>
                        </div>

                        <iframe className="youtube__movie" width="560" height="315" src="https://www.youtube.com/embed/3s_2shU9baY?si=H4QaKE6IIVYRYU0A" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>

                    </section>

                    <section className="ARJack__contents" id="TICKET">
                        <div className="firstanniv__sectionTitle">
                            <h2 className="firstanniv_h2_sectionTitle">TICKET</h2>
                            <div className="firstanniv__sectionBorder"></div>
                            <img className='firstanniv_headingIcon' src={headingIcon} alt="heading icon" />
                        </div>

                        <div className='firstanniv__ticket'>
                            <div className='firstanniv_h3'>ADV / 1,000yen(+1D)<br />
                                DOOR / 2,000yen(+1D) </div>
                            <div className="firstanniv__linkCnotainer">
                                <a className="ARJack__Partnership__partner__link" href="https://bosotokyo231029.peatix.com" target="_blank">Peatix</a>
                                <a className="ARJack__Partnership__partner__link" href="https://passmarket.yahoo.co.jp/event/show/detail/02tu7fjw61c31.html" target="_blank">PassMarket</a>
                            </div>
                        </div>


                        <h3 className="firstanniv_h4">CAUTION</h3>
                        <p className='firstanniv_h5'>チケット購入前に必ずお読みください。</p>
                        <ul className="firstanniv_ul">
                            <li>未成年の入場可能。</li>
                            <li>20歳以上の方は入場時に顔写真付きの身分証を確認させていただきます。確認できない場合、酒類およびシーシャの提供はできません。</li>
                            <li>当日は渋谷のハロウィンになります。交通規制や道中の大変な混雑が予想されますので、お早めの行動をお願いいたします。</li>
                            <li>チケット購入後の返金はできません。あらかじめご了承ください。</li>
                            <li>イベント中および入退場時の怪我やトラブル、貴重品の盗難・紛失等、イベント側は一切の責任を負いません。</li>
                            <li>イベント中は、写真・動画撮影を行いますので、予めご了承ください。</li>
                            <li>イベント内で撮影された写真及び映像に関する著作権は、当イベントの主催に帰属します。本プロジェクトのプロモーション等で使用する場合がありますので、予めご了承下さい。</li>
                            <li>当日メディアの取材が入る場合がございます。</li>
                            <li>本ルールは主催者の判断により、予告無く内容が変更される場合がございます。</li>
                        </ul>
                    </section>

                    <section className="ARJack__contents" id="CREW">
                        <div className="firstanniv__sectionTitle">
                            <h2 className="firstanniv_h2_sectionTitle">BOSO CREW</h2>
                            <div className="firstanniv__sectionBorder"></div>
                            <img className='firstanniv_headingIcon' src={headingIcon} alt="heading icon" />
                        </div>

                        <h3 className='firstanniv_h3'>BOSO TOKYO NFT HOLDER</h3>
                        <p className='firstanniv_h4'>BOSO TOKYOのNFTホルダーは以下の特典があります。</p>

                        <ul className='firstanniv_ul'>
                            <li>入場無料（お連れ様１名まで無料）</li>
                            <li>VIP LOUNGEへの入場可</li>
                            <li>１周年ノベルティ（ラバーバンド、ステッカー）</li>
                            <li>シーシャ無料（一般 1000yen）</li>
                        </ul>
                        <p className='firstanniv_min'>※当日、BOSO TOKYOのNFTの所持を確認させていただきます。</p>
                    </section>

                    <section className="ARJack__contents" id="INFO">
                        <div className="firstanniv__sectionTitle">
                            <h2 className="firstanniv_h2_sectionTitle">INFO&ACCESS</h2>
                            <div className="firstanniv__sectionBorder"></div>
                            <img className='firstanniv_headingIcon' src={headingIcon} alt="heading icon" />
                        </div>

                        <h3 className='firstanniv_h4'>BOSO TOKYO 1st ANIV. PARTY 暴走狂宴<br />
                            2023.10.29 SUN<br />
                            OPEN/START 17:00 - CLOSE 22:00<br />
                            at WOMB</h3>
                        <p className='firstanniv_h5 color_red'>〒150-0044 東京都渋谷区円山町2-16</p>

                        <div className="ARJack__Partnership__partner__linkCnotainer">
                            <a className="ARJack__Partnership__partner__link" href="https://maps.app.goo.gl/rapVYkBYgArR8uDo7" target="_blank">Google map</a>
                        </div>

                        <p className='firstanniv_min'>※当日は渋谷のハロウィンになります。交通規制や道中の大変な混雑が予想されますので、お早めの行動をお願いいたします。</p>
                    </section>

                    <section className="ARJack__contents" id="FAQ">
                        <div className="firstanniv__sectionTitle">
                            <h2 className="firstanniv_h2_sectionTitle">FAQ</h2>
                            <div className="firstanniv__sectionBorder"></div>
                            <img className='firstanniv_headingIcon' src={headingIcon} alt="heading icon" />
                        </div>

                        <h3 className='firstanniv_h4'>Q. 未成年は入場可能ですか？</h3>
                        <p className='firstanniv_h5'>入場可能です。中学生以下は保護者同伴でお願いいたします。</p>

                        <h3 className='firstanniv_h4'>Q. 再入場は可能ですか？</h3>
                        <p className='firstanniv_h5'>再入場は可能です。リストバンドを外したり、破損した場合、再入場はできません。</p>

                        <h3 className='firstanniv_h4'>Q. クロークはありますか？</h3>
                        <p className='firstanniv_h5'>会場備え付けのロッカーをご利用ください（有料）</p>

                    </section>

                    <section className="ARJack__contents" id="GALLERY">
                        <div className="firstanniv__sectionTitle">
                            <h2 className="firstanniv_h2_sectionTitle">GALLERY</h2>
                            <div className="firstanniv__sectionBorder"></div>
                            <img className='firstanniv_headingIcon' src={headingIcon} alt="heading icon" />
                        </div>

                        <div className='GalleryGrid'>
                            <Gallery imgSrc={galleryImg01} />
                            <Gallery imgSrc={galleryImg02} />
                            <Gallery imgSrc={galleryImg03} />
                            <Gallery imgSrc={galleryImg04} />
                            <Gallery imgSrc={galleryImg05} />
                            <Gallery imgSrc={galleryImg06} />
                            <Gallery imgSrc={galleryImg07} />
                            <Gallery imgSrc={galleryImg08} />
                            <Gallery imgSrc={galleryImg09} />
                            <Gallery imgSrc={galleryImg10} />
                            <Gallery imgSrc={galleryImg11} />
                            <Gallery imgSrc={galleryImg12} />
                        </div>
                    </section>

                    <section className="ARJack__Partnership" id="ABOUT">
                        <div className="firstanniv__sectionTitle">
                            <h2 className="firstanniv_h2_sectionTitle">ABOUT</h2>
                            <div className="firstanniv__sectionBorder"></div>
                            <img className='firstanniv_headingIcon' src={headingIcon} alt="heading icon" />
                        </div>
                        <div className="ARJack__Partnership__img">
                            <img src={aboutImg} alt="img" />
                        </div>

                        <h3 className='firstanniv_h3'>BOSO TOKYO</h3>
                        <p className="firstanniv_p">
                            BŌSŌ TOKYO -暴走東京- は、日本を代表するイラストレーター「天神英貴」が、暴走族カルチャー×サイバーSFの世界観で描く、メタバース時代のアイデンティティブランドをつくるプロジェクトです。ユーティリティーとして、唯一無二のアートワーク、そして、PFPに留まらず、クオリティの高い3Dデータの配布やメタバース空間に持ち込めるアバターを用意します。さらに商用利用権の提供や、専用のコミュニティやイベントへのアクセスが可能になります。
                        </p>
                        <div className="ARJack__Partnership__partner__linkCnotainer">
                            <a className="ARJack__Partnership__partner__link" href="https://www.bosotokyo.com/" target="_blank">OFFICIAL Site</a>
                            <a className="ARJack__Partnership__partner__link" href="https://twitter.com/BosoTokyo" target="_blank"><img src={XIcon} alt="X" /></a>
                            <a className="ARJack__Partnership__partner__link" href="https://opensea.io/collection/bosotokyo-official" target="_blank"><img src={OpenseaIcon} alt="Opensea" /></a>
                        </div>
                    </section>

                    <footer className='firstanniv__footer'>
                        <div className='firstanniv__footer__copy'></div>
                        <div className='firstanniv__footer__logo'>
                            <Link to="/" >
                                <img src={FooterLogo} alt="BOSO TOKYO" />
                            </Link>
                        </div>
                    </footer>
                </div>

                <div className='firstanniv_link_fixed'>
                    <a className="firstanniv_link_fixed_link" href="#TICKET">TICKET</a>
                </div>

            </div >
            {/* <Footer /> */}
        </>
    );
}